export const links = [
    {
        id: 0,
        link: '/',
        title: 'início',
    },
    {
        id: 1,
        link: '/sobre',
        title: 'Sobre',
    },
    {
        id: 2,
        link: '/contato',
        title: 'Contato',
    },
];
